
const platformUrl = "https://platform.weros-webdynamics.com/";

function normalizeLanguage(lang) {
  return lang === "de" ? "de" : "en";
}

function updatePlatformLanguageLinks(lang) {
  const normalized = normalizeLanguage(lang);
  const targetHref = `${platformUrl}?lang=${normalized}`;
  document.querySelectorAll("a[data-platform-language-link='1']").forEach((element) => {
    element.setAttribute("href", targetHref);
  });
}

export function setLanguage(lang) {
  const normalized = normalizeLanguage(lang);
  document.body.classList.remove("set-lang-de", "set-lang-en");
  document.body.classList.add("set-lang-" + normalized);
  localStorage.setItem("language", normalized);
  updatePlatformLanguageLinks(normalized);
  document.dispatchEvent(new CustomEvent("language:changed", {
    detail: { language: normalized }
  }));

  
  document.querySelectorAll(".lang-sensitive").forEach((el) => {
    const ph = el.getAttribute("data-placeholder-" + normalized);
    if (ph !== null) el.placeholder = ph;
    const val = el.getAttribute("data-value-" + normalized);
    if (val !== null) el.value = val;
  });

  applyCustomValidation(normalized);
  updateImageAlts(normalized);
}


function applyCustomValidation(lang) {
  document.querySelectorAll("input[required], textarea[required]").forEach((field) => {
    field.oninvalid = function (e) {
      e.target.setCustomValidity(e.target.getAttribute("data-error-" + lang) || "");
    };
    field.oninput = function (e) {
      e.target.setCustomValidity("");
    };
  });
}


function updateImageAlts(lang) {
  document.querySelectorAll("img[data-alt-de][data-alt-en]").forEach((img) => {
    const newAlt = img.getAttribute("data-alt-" + lang);
    if (newAlt !== null) img.alt = newAlt;
  });
}


export function bindLanguageButtons() {
  document.querySelector("#lang-set-de")?.addEventListener("click", () => setLanguage("de"));
  document.querySelector("#lang-set-en")?.addEventListener("click", () => setLanguage("en"));
}
